export const transitionsConfig = [
  {
    key: 'draft_2_wont_do',
    reasons: [
      'In conclusione, importo irrisorio',
      'Attualmente non sta lavorando',
      'Fermo: variante in corso',
      'Subentro di altro fornitore',
      // 'Campo per motivazione libera',
      'Chiuso',
      'Altro',
    ],
    note_enabled: true,
    additional_attributes: [
      {
        key: 'to_not_evaluate',
        value: '1',
      },
    ],
  },
  {
    key: 'to_be_compiled_2_wont_do',
    reasons: [
      'In conclusione, importo irrisorio',
      'Attualmente non sta lavorando',
      'Fermo: variante in corso',
      'Subentro di altro fornitore',
      // 'Campo per motivazione libera',
      'Chiuso',
      'Altro',
    ],
    note_enabled: true,
    additional_attributes: [
      {
        key: 'to_not_evaluate',
        value: '1',
      },
    ],
  }
]

export const formatTransition = (transitionLabel, finalState = false) => {
  if (transitionLabel.indexOf(' |') !== -1) {
    if (finalState) {
      return transitionLabel.substring(transitionLabel.indexOf(' -> ') + 4, transitionLabel.length)
    }
    return transitionLabel.substring(0, transitionLabel.indexOf(' |'))
  }
  return transitionLabel
}

export const getTransitionsFromState = (from, to, transitions) => {
  let ret = null

  if (!to.workflow)
    return ret
  const wf = to.workflow

  for (const transition of transitions[wf]) {
    if (transition.name.startsWith(from) && transition.name.endsWith(to.name)) {
      ret = transition.name
      break
    }
  }
  return ret
}

export function getStateName(stateKey, workflows = []) {
  if (!stateKey) return ''

  stateKey = stateKey.replace('__Number', '')

  for (const wf of workflows) {
    const place = wf.places?.find(p => p.name === stateKey)
    if (place) {
      return place.labels?.it ?? stateKey
    }
  }

  return stateKey
}
